import { gql } from "@apollo/client";

// Main query to fetch user profile
export const FetchMyProfile = gql`
  query fetchMyProfile {
    result: profile {
      profile {
        device_id
        first_run_completed
        force_update
        person {
          id
          first_name
          last_name
          phone_number
          email
          location {
            village
            subdistrict
            district
            province
          }
        }
        organisations {
          id
          name
          type
          timezone
          directions
          accepts_ne_mobile_dropoff
          position {
            type
            coordinates
          }
        }
        payment_provider_config {
          account_name
          bank_account_number
          id
          provider_id
          status
        }
        acl {
          can_niaga
          can_receive_payment
          organisation_permissions {
            organisation_id
            deactivated_at
            employee_write
            bid_read
            bid_write
          }
        }
      }
    }
  }
`;

export const GET_MY_REWARD_PROGRAMS = gql`
  query GetMyRewardPrograms {
    programs: rewards_programs {
      progress_url
    }
  }
`;

export const GET_MY_KYC = gql`
  query getMyKyc {
    kyc: kyc_get_draft {
      draft {
        id
        name
        status
        note
        ktpNumber
        ktpPhotoUri
        ktpSelfieUri
        program
        programUserChoice
      }
    }
  }
`;

export const SAVE_KYC = gql`
  mutation saveKyc($kyc: json!) {
    kyc: kyc_save_draft(object: { draft: $kyc }) {
      response
    }
  }
`;
